export const messages = {
  en: {
    addCommunityPublicity: {
      title: 'Add Community Publicity',
      pubTitle: 'Publicity Title',
      pubType: 'Publicity Type',
      headerPhoto: 'Header Photo',
      activityContent: 'Activity Content',
      back: 'Back',
      submit: 'Submit',
      requiredTitle: 'Required, please fill in the publicity title',
      requiredType: 'Required, please select publicity type',
      requiredContent: 'Required, please enter announcement content',
      requiredHeaderPhoto: 'Required, please upload header photo'
    }
  },
  zh: {
    addCommunityPublicity: {
      title: '添加社区公示',
      pubTitle: '公示标题',
      pubType: '公示类型',
      headerPhoto: '头部照片',
      activityContent: '活动内容',
      back: '返回',
      submit: '提交',
      requiredTitle: '必填，请填写公示标题',
      requiredType: '必填，请选择公示类型',
      requiredContent: '必填，请输入公告内容',
      requiredHeaderPhoto: '必填，请上传头部照片'
    }
  }
}